import { styled } from '@mui/material';
import { NavLink } from 'react-router';

import { ReactNode } from 'react';

import { BackArrowIcon } from '@app-velocity/icons';
import { Typography } from '@app-velocity/ui';

export type PageBackHeaderProps = {
  title: ReactNode | null;
  backLabel?: string;
  back?: string;
};

const StyledBackLink = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  textDecoration: 'none',
  color: 'var(--text-text-tertiary-color)',
  fontWeight: 'var(--font-weight-regular)',
  fontSize: 'var(--font-size-regular)',
  lineHeight: 'var(--line-height-medium)',
  svg: {
    fill: 'var(--icon-icon-tertiary-color)',
  },
}));

export const PageBackHeaderPrimary = ({
  title,
  backLabel,
  back,
}: PageBackHeaderProps) => {
  return (
    <>
      {back ? (
        <StyledBackLink to={back}>
          <BackArrowIcon />
          {backLabel}
        </StyledBackLink>
      ) : null}
      {title !== null ? (
        <Typography variant="header" component="h1">
          {title}
        </Typography>
      ) : null}
    </>
  );
};
